import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updateDiseaseProtocol } from 'api/auth.api';

export const useUpdateDiseaseProtocol = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateDiseaseProtocol,

    onSuccess: (res) => {
      toast({
        title: 'Disease protocol updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
